/**
 * Where to write: the address in About and the "Report an error" link in each
 * tool's note. A report names the tool and nothing else — never what was
 * typed or what a tool produced (the rule of utils/analytics.js).
 */

export const CONTACT_EMAIL = 'unveil888@pm.me';

/** A mailto: link to report an error in a tool: the subject names the tool and its address. */
export function errorReportHref(tool) {
  const subject = `Error in ${tool.label} (unveil.tools/${tool.id})`;
  const body = 'Where it is (tab, setting, result):\n\nWhat is wrong:\n\nThe source that shows it, if you have one:\n';
  return `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
